import React, { useEffect, useState } from "react";
import googlePlay from "../../../assets/img/GooglePlay.svg";
import TabLaptopImg from "../../../assets/img/laptopTabImg.png";
import { useHistory } from "react-router-dom";
import { i18n } from "../private/languageSelector";
import { GOOGLE_PLAY_URL, HomePageContentCards, homePageContentTabs } from "../../../helpers/constants";
import { recordAnalyticsEvent } from "../../modules/Auth/_redux/authCrud";

const HomeContainer = () => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const history = useHistory();
  const selectedLanguage = localStorage.getItem("language");

  const goToBenefits = (id) => {
    history.push(`/homePage?section=${id}`, { [id]: true });
    setTimeout(() => {
      const element = document.getElementById("home_wrapper_main");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const handlePosDownloadClick = async () => {
    try {
      const visitorId = localStorage.getItem("visitorId") || crypto.randomUUID();

      localStorage.setItem("visitorId", visitorId);
      await recordAnalyticsEvent({
        type: "app_click",
        platform: "web",
        visitorId,
        country: "",
      });
    } catch (error) {
      console.error("Failed to record app click analytics:", error);
    }
  };

  return (
    <div className="pos-wrapper">
      {" "}
      <div className="pos-view p-4 align-center">
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            className={`row pos-view-wrapper  ${
              selectedLanguage === "arabic" ? "flex-row-reverse text-right justify-content-between" : "flex-row text-left"
            }`}
          >
            <div className="col-lg-7 pt-3">
              <h2
                className=" pt-2"
                style={{
                  fontWeight: "700",
                  color: "#333333",
                  textAlign: screenSize < 1006 ? "center" : "",
                  direction: selectedLanguage === "arabic" ? "rtl" : "ltr",
                }}
              >
                {i18n("HomePage.FreePosSoftware")}
              </h2>
              {screenSize > 1006 ? (
                <h3
                  className="mb-2"
                  style={{
                    fontWeight: "400",
                    color: "#333333",
                    marginTop: "49px",
                    direction: selectedLanguage === "arabic" ? "rtl" : "ltr",
                    lineHeight: "45px",
                  }}
                >
                  {/* Empower your tablet for sales, Manage invoices, track customers, boost revenue, and enhance your brand. */}
                  {i18n("HomePage.PosDetails")}
                </h3>
              ) : null}

              {screenSize > 1006 ? (
                <button
                  style={{
                    height: "47px",
                    marginTop: "63px",
                    borderRadius: "8px",
                    border: "0",
                    backgroundColor: "#9B51E0",
                    color: "#FFFFFF",
                  }}
                  onClick={() => history.push("/auth/registration")}
                >
                  <p
                    style={{
                      margin: "0",
                      padding: "8px 28px",
                      fontWeight: "700",
                      fontSize: "16px",
                      lineHeight: "21.79px",
                    }}
                  >
                    {/* TRY FATORATY NOW */}
                    {i18n("HomePage.TryFatoratyNow")}
                  </p>
                </button>
              ) : null}
            </div>
            <div className="laptop-img-wrapper col-lg-4" style={{ marginTop: "30px" }}>
              <div className="img-wrapper">
                <img className="laptopImg" src={TabLaptopImg} alt="laptop" />
              </div>
              <div>
                {screenSize < 1006 ? (
                  <h3
                    className="mb-2"
                    style={{ fontWeight: "400", color: "#333333", marginTop: "22px", textAlign: screenSize < 1006 ? "center" : "" }}
                  >
                    {/* Empower your tablet for sales, Manage invoices, track customers, boost revenue, and enhance your brand. */}
                    {i18n("HomePage.PosDetails")}
                  </h3>
                ) : null}
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: screenSize < 700 ? "0 20px" : "0 18px" }}>
        <div className="media_links" style={{ margin: screenSize < 700 ? "30px 0" : "21px 0" }}>
          <div className={`row ${selectedLanguage === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
            <div className="col-lg-2 col-4">
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" onClick={handlePosDownloadClick}>
                <img style={{ width: "100%" }} src={googlePlay} alt="google_play" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="started-header">
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <p className="tool-text" style={{ fontWeight: "600", fontSize: "35px", color: "#FFFFFF", textAlign: "center" }}>
            {i18n("HomePage.EasyToolsToExpandBusiness")}
          </p>
        </div>
      </div>
      {/* tabs section  */}
      <div style={{ background: "#FFFFFF", paddingTop: screenSize > 1200 ? "2rem" : "0rem", paddingBottom: screenSize > 1200 ? "2rem" : "0rem" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "ARABIC" ? "rtl" : "ltr" }}>
          {screenSize > 1200 ? (
            <div
              className={`d-flex home-tabs-wrapper justify-content-between align-items-center ${
                selectedLanguage === "arabic" ? "flex-row-reverse" : "flex-row"
              }`}
              style={{ gap: "1rem" }}
            >
              {homePageContentTabs?.map((item, index) => {
                return (
                  <div className="tabs-container" key={index}>
                    <a href={`#${item?.id}`}> {selectedLanguage === "arabic" ? item?.arabicLabel : item?.label}</a>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
      {/* content cards*/}
      <div className={`w-100 bg-[#FFFFFF]`}>
        <div>
          {HomePageContentCards?.map((item, index) => {
            return (
              <div
                className={` ${screenSize > 1200 ? "my-5 " : "my-2"}`}
                style={{
                  background: index % 2 === 1 ? "#F8FAFD" : "#FFFFFF",
                  paddingTop: "3rem",
                  paddingBottom: "2rem",
                  direction: selectedLanguage === "arabic" ? "rtl" : "ltr",
                }}
                id={item?.id}
                key={index}
              >
                <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "ARABIC" ? "rtl" : "ltr" }}>
                  {screenSize > 1200 ? (
                    <div
                      className={`row ${screenSize > 1200 ? "my-4" : "my-0"} ${selectedLanguage === "arabic" ? "text-right rtl" : "text-left ltr"} ${
                        index % 2 === 1 ? "flex-row-reverse" : "flex-row"
                      } justify-content-between align-items-center`}
                    >
                      <div className={`col-6  content-cards-wrapper`}>
                        <div className="label-text">{selectedLanguage === "arabic" ? item?.arabicLabel : item?.label}</div>
                        <div className="details-text mt-5">{selectedLanguage === "arabic" ? item?.arabicDetails : item?.details}</div>
                        <div className="points-container mt-5">
                          {item?.points?.map((point, index) => {
                            return (
                              <ul key={index} style={{ listStyle: "disc", paddingLeft: "1rem", paddingRight: "1rem", color: "#333333" }}>
                                <li className="mx-3">{selectedLanguage === "arabic" ? point?.arabicLabel : point?.label}</li>
                              </ul>
                            );
                          })}
                        </div>
                        {item?.id !== "customer_management" && item?.id !== "more_features" ? (
                          <div
                            onClick={() => {
                              goToBenefits(item?.id);
                            }}
                            className="more-text cursor-pointer mt-4 "
                          >
                            {selectedLanguage === "arabic" ? "إكتشف المزيد.." : "More..."}{" "}
                          </div>
                        ) : null}
                      </div>
                      <div className={`col-6`}>
                        <img src={selectedLanguage === "arabic" ? item?.arabicImg : item?.img} alt="banner" width={570} />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className={`row ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
                        <div className={`col-12 content-cards-wrapper`}>
                          <div className="label-text">{selectedLanguage === "arabic" ? item?.arabicLabel : item?.label}</div>
                          <div className="details-text mt-5">{selectedLanguage === "arabic" ? item?.arabicDetails : item?.details}</div>
                          <img className="mt-5 mx-auto " src={item.img} alt="banner" width={"100%"} />
                        </div>
                        <div className={`col-12`}>
                          <div className="points-container d-flex flex-column mt-5">
                            {item?.points?.map((point, index) => {
                              return (
                                <ul key={index} style={{ listStyle: "disc", paddingLeft: "1rem", paddingRight: "1rem", color: "#333333" }}>
                                  <li className="mx-3">{selectedLanguage === "arabic" ? point?.arabicLabel : point?.label}</li>
                                </ul>
                              );
                            })}
                          </div>
                          {item?.id !== "customer_management" && item?.id !== "more_features" ? (
                            <div onClick={() => goToBenefits(item?.id)} className="more-text cursor-pointer mt-4">
                              {selectedLanguage === "arabic" ? "إكتشف المزيد.." : "More..."}{" "}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HomeContainer;
